export const maskPhoneNumber = (number?: string): string => {
  if (number === undefined) {
    return ''
  }
  const onlyNumbers = (number ?? '').replace(/[^\d]/g, '')
  if (onlyNumbers.length === 0) {
    return ''
  }
  const last3 = onlyNumbers.substring(onlyNumbers.length - 3)
  const mask = ['•••']
  if (last3.length > 0) {
    mask.push(last3)
  }
  return mask.join(' ')
}

export const phoneNumberIsCleared = (number: string = ''): boolean => {
  return number.startsWith('CLEARED_')
}
